import { GsFormSchema } from 'libs/shared/src/components/gs-form/interfaces/gs-form-schema';
import { HORIZONTAL_ALIGNMENT_SCHEMA } from './alignment.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the forgot user data component form.
 * Defines the fields to display for the form.
 */
export const FORGOT_USER_DATA_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...HORIZONTAL_ALIGNMENT_SCHEMA,
    ...SPACING_SCHEMA,
    {
      formControlName: 'buttons',
      label: 'components.forgotUserData.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    },
    {
      formControlName: 'buttonText',
      label: 'components.forgotUserData.schema.buttonText',
      type: 'text',
      inputType: 'text',
      default: 'Send email'
    }
  ]
};
